import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_chevron-up",
  "use": "icon_chevron-up-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon_chevron-up\"><path d=\"M12.777 6.184l8.901 8.901a1.1 1.1 0 010 1.555l-1.038 1.038a1.1 1.1 0 01-1.553.002L12 10.625 4.913 17.68a1.099 1.099 0 01-1.553-.002l-1.038-1.039a1.1 1.1 0 010-1.554l8.901-8.9a1.1 1.1 0 011.554 0z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol